import { LogoMark } from "@/components/logo/AetriaLogo";
import { logoSrc, useBranding } from "@/context/BrandingContext";

export const BrandMark = ({ size = 34, inverted = false }) => {
  const { branding } = useBranding();
  if (!branding || branding.product_name === "Aetria OS") {
    return <LogoMark size={size} inverted={inverted} />;
  }
  if (branding.has_logo) {
    return (
      <img
        data-testid="brand-logo-img"
        src={logoSrc()}
        alt={branding.product_name}
        style={{ height: size, width: "auto", maxWidth: size * 2.6, objectFit: "contain" }}
      />
    );
  }
  return (
    <div
      data-testid="brand-monogram"
      className="flex items-center justify-center shrink-0 border border-white/20 relative"
      style={{ width: size, height: size, background: "var(--brand-primary)" }}
    >
      <span style={{ color: "#fff", fontWeight: 800, fontSize: size * 0.48, lineHeight: 1 }}>
        {branding.product_name[0].toUpperCase()}
      </span>
      <div
        className="absolute bottom-0 left-0 right-0"
        style={{ height: Math.max(2, size * 0.09), background: "var(--brand-accent)" }}
      />
    </div>
  );
};

export const BrandName = ({ className = "" }) => {
  const { branding } = useBranding();
  const name = branding?.product_name || "Aetria OS";
  const parts = name.split(" ");
  const head = parts.length > 1 ? parts.slice(0, -1).join(" ") : name;
  const tail = parts.length > 1 ? parts[parts.length - 1] : "";
  return (
    <span className={className} data-testid="brand-product-name">
      {head.toUpperCase()}
      {tail && <span className="ml-1" style={{ color: "var(--brand-accent)" }}>{tail.toUpperCase()}</span>}
    </span>
  );
};
